import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { MediaCategory } from '@src/api/types/mediaCategory';

type MediaCategoryIndexResponse = MediaCategory[];

export const mediaCategoryApiClient = {
  index: async (): Promise<ApiResult<MediaCategoryIndexResponse>> => {
    return await axiosClient.get('/company/media-categories');
  },
};
